<template>
  <b-form-group class="mb-3" label="CPF / CNPJ">
    <b-form-input
      type="text"
      v-mask="mask"
      :state="computedState"
      :class="inputClass"
      v-model="inputValue"
      @input="handleInput"
      :placeholder="placeholder"
    />
    <b-form-invalid-feedback v-if="showRequiredError">
      CPF / CNPJ é obrigatório.
    </b-form-invalid-feedback>
    <b-form-invalid-feedback v-else-if="!computedState">
       {{ errorMessage }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
export default {
  props: {
    inputClass: {
      type: [String, Array, Object],
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    errorMessage: {
      type: String,
      default: 'CPF / CNPJ inválido.',
    },
    state: {
      type: Boolean,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    submitted: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      internalIsValid: null,
      inputValue: this.value,
    };
  },
  watch: {
    inputValue(newValue) {
      this.$emit('input', newValue);
      this.handleInput(newValue);
    },
    value(newValue) {
      this.inputValue = newValue;
    },
    state(newState) {
      if (newState !== null) {
        this.internalIsValid = newState;
      }
    },
    submitted(newVal) {
      if (newVal && this.required) {
        this.validateEmptyField();
      }
    }
  },
  computed: {
    mask() {
      const cleanValue = this.inputValue.replace(/\D/g, '');
      return cleanValue.length <= 11 ? '###.###.###-##' : '##.###.###/####-##';
    },
    computedState() {
      if (this.state !== null && this.state !== undefined) {
        return this.state;
      }
      return this.internalIsValid;
    },
    showRequiredError() {
      return this.submitted && this.required && (!this.inputValue || this.inputValue.trim() === '');
    }
  },
  methods: {
    handleInput(value) {
      if (!value || value.trim() === '') {
        this.internalIsValid = null;
        this.$emit('update:isValid', null);
        return;
      }

      this.internalIsValid = this.isValidCpfCnpj(value || this.inputValue);
      this.$emit('update:isValid', this.internalIsValid);
    },

    validateEmptyField() {
      if (this.required && (!this.inputValue || this.inputValue.trim() === '')) {
        this.internalIsValid = false;
        this.$emit('update:isValid', false);
      }
    },

    isValidCpfCnpj(value) {
      if (typeof value !== 'string' && typeof value !== 'number') return false;
      const cleanValue = String(value).replace(/\D/g, '');

      if (cleanValue.length === 11) {
        return this.isValidCpf(cleanValue);
      } else if (cleanValue.length === 14) {
        return this.isValidCnpj(cleanValue);
      }
      return false;
    },

    isValidCpf(cpf) {
      cpf = cpf.replace(/[^\d]+/g, '');
      if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

      let soma = 0;
      let resto;

      for (let i = 1; i <= 9; i++) soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
      resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== parseInt(cpf.substring(9, 10))) return false;

      soma = 0;
      for (let i = 1; i <= 10; i++) soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
      resto = (soma * 10) % 11;
      if (resto === 10 || resto === 11) resto = 0;
      if (resto !== parseInt(cpf.substring(10, 11))) return false;

      return true;
    },

    isValidCnpj(cnpj) {
      cnpj = cnpj.replace(/[^\d]+/g, '');
      if (cnpj.length !== 14) return false;

      let tamanho = cnpj.length - 2;
      let numeros = cnpj.substring(0, tamanho);
      let digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;

      for (let i = tamanho; i >= 1; i--) {
        soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
        if (pos < 2) pos = 9;
      }

      let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(0)) return false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;

      for (let i = tamanho; i >= 1; i--) {
        soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
        if (pos < 2) pos = 9;
      }

      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(1)) return false;

      return true;
    }
  },
};
</script>

<style lang="scss" scoped>
.form-control {
  height: 32px;
}

.form-control::placeholder {
  height: 32px;
  opacity: 0.4;
}
</style>
